export default "__VITE_ASSET__C0B0jOFh__"